import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment.development";
import {FrmPasoItem} from "../interfaces/shared-interface";

const apiVucUrl = environment.apiVucUrl
@Injectable({providedIn: 'root'})
export class FrmService {
    constructor(private http: HttpClient) {
    }
    getPasosFU() {
        let idFormularioUnico = 4;
        let url = apiVucUrl + `api/v1.0/formularios/pasos/${idFormularioUnico}`;
        return this.http.get<FrmPasoItem[]>(url);
    }
}
